exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea[data-v-42177620] {\n    width: 100%;\n    height: 100px;\n}\n.share-type[data-v-42177620] {\n    margin-bottom: 12px;\n}\nlabel[data-v-42177620] {\n    font-weight: bold;\n}\n.content[data-v-42177620] {\n    width: 420px;\n}\n.auth-note[data-v-42177620] {\n    margin-top: 8px;\n}\n", ""]);

// exports
